import type { Document } from "@contentful/rich-text-types";
import { RichTextRenderer } from "@scott/contentful/rich-text-renderer";
import { cva } from "class-variance-authority";
import { TextD2C } from "../../elements/text-d2c/text";
import { Column, Container, Row } from "../../layout/grid";
import { cn } from "../../lib/utils";
import type { TaglineSectionInspectorProps } from "./tagline-section.preview";

export interface TaglineSectionProps {
  sys?: { id: string };
  paddingTop?: "none" | "small" | "medium" | "large";
  paddingBottom?: "none" | "small" | "medium" | "large";
  backgroundColor?: "black" | "white";
  color?: "black" | "white";
  text?: { json?: Document; sys?: { id: string; locale?: string } };
  anchorId?: string;
  inspectorProps?: TaglineSectionInspectorProps;
}

const taglineSectionVariants = cva("", {
  variants: {
    backgroundColor: {
      white: "bg-white",
      black: "bg-black",
    },
  },
  defaultVariants: {
    backgroundColor: "black",
  },
});

export function TaglineSection({
  text,
  backgroundColor,
  color,
  inspectorProps,
  ...props
}: Readonly<TaglineSectionProps>) {
  const variantClasses = taglineSectionVariants({ backgroundColor });
  const effectiveBackgroundColor = backgroundColor ?? "black";
  const textColor =
    color ?? (effectiveBackgroundColor === "black" ? "white" : "black");

  return (
    <Container
      className={cn(variantClasses, "component-tagline-section")}
      fullWidth={true}
      id={props.anchorId}
      paddingBottom={props.paddingBottom}
      paddingTop={props.paddingTop}
      test-id="tagline-section"
      {...inspectorProps?.container}
    >
      <Row>
        <Column className="col-span-12 text-center [&_h2]:hyphens-none [&_h2]:break-normal">
          <TextD2C color={textColor} variant="h2" {...inspectorProps?.text}>
            <RichTextRenderer richText={text?.json} />
          </TextD2C>
        </Column>
      </Row>
    </Container>
  );
}
